
import React from 'react'
import Button from '../../../../utils/components/Button/Button'
import { Table } from '../../../components/Table/Table'

const DevolutionsDetailView = ({ devolutionsDetail, erese, refund, specifications, accept }) => {
  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>
              Cantidad a devolver
            </th>
            <th>
              Producto
            </th>
            <th>
              Razón de devolución
            </th>
            <th>
              Acción
            </th>
          </tr>
        </thead>
        <tbody>
          {
            devolutionsDetail.map(devolutionDetail => (
              <tr key={devolutionDetail._id}>
                <td>
                  {devolutionDetail.quantityReturned}
                </td>
                <td>
                  {devolutionDetail.productId.name}
                </td>
                <td>
                  {devolutionDetail.reasonForReturnId.name}
                </td>
                <td>
                  <div className='column'>
                    <Button text='Eliminar y devolver' onClick={() => { erese(devolutionDetail) }}
                      active={
                        specifications.find(specification => specification.detailId ===devolutionDetail._id) != undefined && specifications.find(specification => specification.detailId ===devolutionDetail._id).status ===1
                      } />
                    <Button text='Retornar' onClick={() => { refund(devolutionDetail) }}
                      active={
                        specifications.find(specification => specification.detailId ===devolutionDetail._id) != undefined && specifications.find(specification => specification.detailId ===devolutionDetail._id).status ===2
                      } />
                  </div>
                </td>
              </tr>
            ))
          }
        </tbody>
      </Table>
      <Button text='Aceptar' onClick={() => {
        accept()
      }} />
    </div>
  )
}

export default DevolutionsDetailView